<template>
  <div :class="{ 'sidebar-position-edit': true }">
    <SidebarTopRightOrientation>
      <div class="sidebar-top-right-orientation__right">
        <button
          @click="closeSidebarPositionEdit"
          class="sidebar-top-right-orientation__button"
        >
          <div class="sidebar-top-right-orientation__button__text">Sluit</div>
          <svg class="sidebar-top-right-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>
    </SidebarTopRightOrientation>

    <div class="sidebar-position-edit__bottom">
      <template v-if="activePosition">
        <div class="sidebar-position-edit__infobar">
          <SidebarTitleBar>
            <div
              class="sidebar-title-bar__icon-container"
              @click="openSidebarPositionIndex"
              :style="{ fill: appAsset ? appAsset.color_primary : '#101010' }"
            >
              <svg svg-inline="" class="sidebar-title-bar__icon-container__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
            </div>

            <div class="sidebar-title-bar__inner">
              <div class="sidebar-title-bar__inner__left">
                <div
                  class="sidebar-title-bar__inner__left__title"
                  :style="{ color: appAsset ? appAsset.color_primary : null }"
                >
                  Straal wijzigen
                </div>
              </div>
              <div class="sidebar-title-bar__inner__right">
                <div
                  class="sidebar-title-bar__inner__right__text-right"
                  @click="deletePosition"
                  :style="{ color: appAsset ? appAsset.color_primary : null }"
                >
                  Verwijder
                </div>
              </div>
            </div>
          </SidebarTitleBar>
        </div>

        <div
          class="sidebar-position-edit__map"
          id="sidebarPositionEditMap"
          ref="sidebarPositionEditMap"
        ></div>

        <div class="sidebar-position-edit__map-bottom">
          <div class="sidebar-position-edit__map-bottom__title">
            {{ activePosition.address }}
          </div>
          <div class="sidebar-position-edit__map-bottom__subtitle">
            {{ activePosition.gemeente.name }}
          </div>

          <label
            for="radius-select"
            class="sidebar-position-edit__radius-select-label"
            >Toon meldingen in een straal van {{ radius }} meter:</label
          >
          <vue-slider
            class="sidebar-position-edit__radius-select"
            id="radius-select"
            :min="100"
            :max="1000"
            v-model="radius"
            tooltip="none"
          />
        </div>
      </template>
    </div>

    <portal to="page-shadow">
      <PageShadow />
    </portal>
  </div>
</template>

<script>
import debounce from "@/services/Debounce.js";
import PrivateApi from "@/services/PrivateApi.js";
import PageShadow from "@/components/PageShadow.vue";
import SidebarTopRightOrientation from "@/components/SidebarTopRightOrientation.vue";
import SidebarTitleBar from "@/components/SidebarTitleBar.vue";
import gmapsInit from "@/utils/gmaps";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  data() {
    let activePosition = this.$store.state.ui.activePosition;
    return {
      activePosition: activePosition,
      radius: activePosition.radius,
      appAsset: activePosition.gemeente.app_asset
        ? activePosition.gemeente.app_asset
        : null
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.appAsset ? this.appAsset.color_primary : "#6DCC00",
          vmid: "theme-color"
        }
      ]
    };
  },
  async mounted() {
    try {
      let self = this;
      let mapId = this.$refs.sidebarPositionEditMap;

      if (this.activeView) {
        gmapsInit().then(function(google) {
          self.google = google;
          var map = new google.maps.Map(mapId, {
            disableDefaultUI: true
          });
          self.map = map;

          var initPosition = {
            lat: self.activePosition.latitude,
            lng: self.activePosition.longitude
          };
          map.setCenter(initPosition);

          var marker = new self.google.maps.Marker({
            map: map,
            position: initPosition,
            icon: {
              url: "/ic_location@2x.png",
              anchor: new google.maps.Point(16, 16),
              scaledSize: new google.maps.Size(32, 32)
            }
          });

          var circle = new self.google.maps.Circle({
            map: map,
            strokeWeight: 0,
            fillColor: self.appAsset ? self.appAsset.color_primary : "#6DCC00",
            fillOpacity: 0.33,
            center: initPosition,
            radius: self.radius
          });

          map.fitBounds(circle.getBounds(), 0);

          self.marker = marker;
          self.circle = circle;
        });
      }
    } catch (error) {
      console.error(error);
    }
  },
  components: {
    PageShadow,
    SidebarTopRightOrientation,
    SidebarTitleBar,
    VueSlider
  },
  methods: {
    activeView() {
      return this.$store.state.ui.sidebarPositionEdit;
    },
    closeSidebarPositionEdit() {
      this.$store.commit("closeSidebarPositionEdit");
    },
    openSidebarPositionIndex() {
      this.$store.commit("closeSidebarPositionEdit");
      this.$store.commit("openSidebarPositionIndex");
    },
    deletePosition() {
      let self = this;
      let answer = confirm("weet je het zeker?");

      if (answer) {
        PrivateApi()
          .delete(`positions/${this.activePosition.id}`)
          .then(function() {
            self.$store.commit("closeSidebarPositionEdit");

            let loadedPositions = self.$store.state.data.loadedPositions;
            let index = loadedPositions.data.findIndex(
              x => x.id == self.activePosition.id
            );

            loadedPositions.data.splice(index, 1);
            self.$store.commit("setUpdatedPositionCount", true);
            self.$store.commit("setLoadedPositions", loadedPositions);
            self.$store.commit("setHomePosition", loadedPositions.data[0]);
          });
      }
    }
  },
  watch: {
    radius: debounce(function(radius) {
      let self = this;
      this.circle.setRadius(parseInt(this.radius));
      this.map.fitBounds(this.circle.getBounds(), 0);
      let data = { radius: radius };

      PrivateApi()
        .put(`positions/${this.activePosition.id}`, data)
        .then(function() {
          let loadedPositions = self.$store.state.data.loadedPositions;
          let index = loadedPositions.data.findIndex(
            x => x.id == self.activePosition.id
          );
          loadedPositions.data[index].radius = parseInt(radius);
          self.$store.commit("setLoadedPositions", loadedPositions);
        });
    }, 100)
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-edit {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;

  #sidebarPositionEditMap {
    width: 100%;
    height: 300px;
  }

  &__top {
    background: #fff;
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: $spacing-3;
  }

  &__infobar {
    padding: $spacing-3;
    background: #fff;
  }

  &__radius-select-label {
    display: inline-block;
    margin-top: $spacing-6;
    @extend %text-small;
  }

  &__bottom {
    flex: 1;
    overflow-y: auto;
  }

  &__map-bottom {
    padding: $spacing-3;
    background: #fff;

    &__title {
      @extend %text-title-1;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__subtitle {
      @extend %text-large-light;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
    }
  }
}

@media (min-width: 768px) {
  .sidebar-position-edit {
    &__top {
      padding-left: $spacing-4;
    }
    &__infobar {
      padding: $spacing-4;
    }
    &__map-bottom {
      padding: $spacing-4;
    }
  }
}
</style>
